module.exports = __webpack_public_path__ + "static/media/chamberlins.b389fb8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/whereToBuy/stores/chamberlins.jpg
// module id = 247
// module chunks = 0